export const config = {
  webDomain: process.env.REACT_APP_WEB_DOMAIN,
  apiDomain: process.env.REACT_APP_API_DOMAIN,
  env: process.env.REACT_APP_ENVIRONMENT,
  releaseVersion: process.env.REACT_APP_VERSION
}
